import { netsparkAxios } from 'core/services/HTTPService';
import { customersDraftUrl } from './apiUrls';

const postCustomersDraft = () => netsparkAxios.post(customersDraftUrl);

export default postCustomersDraft;
